import { Controller } from '@hotwired/stimulus'

// Where each slide's content sat when its answers were last shown or hidden. The slide is
// centred (blocks.css), so the cards would otherwise re-centre as they grow and the toolbar
// would move under the pointer; pinned, they grow and shrink below it instead. A window
// resize centres the slide again.
const pinnedTops = new Map()

// Shows and hides a slide's answers. The cards draw both states and CSS picks one
// from data-responses-shown; the choice is remembered per class and slide so it
// survives the live re-render that every answer triggers.
export default class extends Controller {
  static values = { id: String }

  connect() {
    this.element.toggleAttribute('data-responses-shown', localStorage.getItem(this.idValue) !== null)
    this.place()
  }

  toggleResponses() {
    pinnedTops.set(this.idValue, getComputedStyle(this.element).marginTop)
    this.place()

    if (this.element.toggleAttribute('data-responses-shown')) {
      localStorage.setItem(this.idValue, true)
    } else {
      localStorage.removeItem(this.idValue)
    }
  }

  recentre() {
    pinnedTops.delete(this.idValue)
    this.place()
  }

  place() {
    this.element.style.marginTop = pinnedTops.get(this.idValue) ?? ''
  }
}
